import { useState, useEffect } from 'react'
import api, { BMDialogFloor } from '@api'

interface IState {
  floor?: BMDialogFloor
  isLoading: boolean
}

interface IFloorHook extends IState {
  update: (floor: BMDialogFloor) => void
  refresh: () => Promise<BMDialogFloor>
}

export default function useFloor(id: string): IFloorHook {
  const [isLoading, setIsLoading] = useState(true)
  const [floor, setFloor] = useState<BMDialogFloor | undefined>(undefined)

  function fetchFloor(id: string) {
    return api.building.floor.details(id).then((floor: BMDialogFloor) => {
      setIsLoading(false)
      setFloor(floor)
      return floor
    })
  }

  useEffect(() => {
    fetchFloor(id)
  }, [id])

  return {
    isLoading,
    floor,
    update: (floor) => setFloor(floor),
    refresh: () => fetchFloor(id),
  }
}
